import { Component, OnInit } from '@angular/core';
// import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ClassService } from '../services/class.service';
import { CompanyDetailsService } from '../services/company-details.service';
import { LoaderService } from '../services/loader.service';
import { LogService } from '../services/log.service';
import { PaymentService } from '../services/payment.service';
import { ResultService } from '../services/result.service';
import { SemesterService } from '../services/semester.service';
import { UserService } from '../services/user.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-term-report-sheets',
  templateUrl: './term-report-sheets.component.html',
  styleUrls: ['./term-report-sheets.component.css']
})
export class TermReportSheetsComponent implements OnInit {


  public loading = true;
  public arr: any = [];
  public termLabels: any = [];
  public term_id: any;
  public student: any;
  public company: any;
  public term_index: any;
  public term_map = false;
  public fetch_for_all = false;
  public limit_arm = false;
  public cum_wtd = false;
  public subject_position = false;
  public class_position = false;
  public dob = false;
  public hilo = false;
  public use_avg = false;
  public vert = false;

  public controlCA1 = false;
  public controlCA2 = false;
  public controlExam = false;
  public ca1Value: any;
  public ca2Value: any;
  public examValue: any;
  public ca1Name: any = "";
  public ca2Name: any = "";
  public examName: any = "";
  resultSetArr: any[] = [];

  public printTitle: any;
  public printAllTitle = 'TERM REPORT SHEETS';

  constructor (
    private sanitizer: DomSanitizer,
    private _resultService: ResultService,
    private _companyDetailsService: CompanyDetailsService,
    public cl: ClassService,
    private _userService: UserService,
    public dialog: MatDialog,
    public _paymentService: PaymentService,
    private _loaderService: LoaderService,
    public sem: SemesterService,
    public log: LogService
  ) { }

  ngOnInit () {
    this.loading = true;


    this._resultService.getReportConfig().subscribe((data: any) => {
      this.subject_position = data.subject_position === 'Y';
      this.class_position = data.class_position === 'Y';
      this.dob = data.dob === 'Y';
      this.hilo = data.hilo === 'Y';
      this.limit_arm = data.limit_arm === 'Y';
      this.fetch_for_all = data.fetch_for_all === 'Y';
      this.cum_wtd = data.cum_wtd === 'Y';
      this.vert = data.vert === 'Y'
      if (this.cum_wtd) {
        this.term_map = data.term_map === 'Y';
        this.use_avg = data.use_avg === 'Y';
      }
    });

    forkJoin([
      this._companyDetailsService.getDetails(),
      this._resultService.termReportSheets()
    ]).subscribe(([company, termReports]) => {
      company.allow_portal_result_print = !!Number(company.allow_portal_result_print); // to boolean
      this.company = company;
      this.termLabels = termReports.map(report => ({
        label: report.label,
        term_id: report.term_id,
        session_id: report.session_id
      }))

      this.arr = termReports

      console.log(termReports);
      if (this.arr.length > 0) {
        this.onTermChange(this.arr[0].term_id)
        this.loading = false;
        let student = this.arr[0]
        this.printAllTitle = `Term Reports for ${student.student_name} (${student.matric_no}) `.toUpperCase();
      }
    }, _ => {
      this.loading = false;
    });
  }


  onTermChange (term_id: any) {
    this.term_id = term_id;
    // this.loading = true;

    const term = this.termLabels.find(x => x.term_id == term_id);
    let index = this.arr.findIndex((x: any) => x.term_id == term_id);
    if (index != -1) {
      this.student = this.arr[index];
      let student = this.student;

      let arm = `${this.student?.category} - ${this.student?.name} -  ${this.student?.tag}`;

      this.printTitle =
        `Term Report for ${student.student_name} (${student.matric_no}) : ${arm} : ${this.student?.term} ${this.student?.session_year}`.toUpperCase();


      if (this.student.new_version) {
        let cd = this.student.cd;
        this.controlCA1 = cd.ca1_visibility == "Y";
        this.ca1Name = cd.ca1_name;
        this.ca1Value = cd.ca1_value;

        this.controlCA2 = cd?.ca2_visibility == "Y";
        this.ca2Name = cd?.ca2_name;
        this.ca2Value = cd?.ca2_value;

        this.controlExam = cd?.exam_visibility == "Y";
        this.examName = cd?.exam_name;
        this.examValue = cd?.exam_value;

        setTimeout(() => {
          this.loading = false;
        }, 500);

      }
      if (!this.student.new_version) {
        const { cat_id, c_id, term_index } = this.student;
        // this.resultSettingInit({ keys: true, cat_id, c_id })
      }



    }


  }




  resultSettingInit (data: any) {
    this._resultService.ResultEntrySettings(data).subscribe((data: any) => {
      this.resultSetArr = [...data];

      if (this.resultSetArr.length > 0) {
        this.ca1Value = this.resultSetArr[0].value;
        this.controlCA1 = this.resultSetArr[0].visibility;
        this.ca1Name = this.resultSetArr[0].settings_name;

        this.ca2Value = this.resultSetArr[1].value;
        this.controlCA2 = this.resultSetArr[1].visibility;
        this.ca2Name = this.resultSetArr[1].settings_name;

        this.examValue = this.resultSetArr[2].value;
        this.controlExam = this.resultSetArr[2].visibility;
        this.examName = this.resultSetArr[2].settings_name;
      }

      setTimeout(() => {
        this.loading = false;
      }, 500);
    });
  }

  print (all = false) {
    let mywindow = window.open("", "PRINT", "height=700,width=1000");
    mywindow.document.write(this._resultService.getPrintHead(all ? this.printAllTitle : this.printTitle));
    mywindow.document.write(
      `<body class="p-4 pt-8">
          <div class="w-full">
            ${document.getElementById(all ? 'print-all-report' : 'print-report').innerHTML}
          </div>
        </body>
      </html>
      `
    )

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.onload = function () {
      mywindow.print();
    };
    // //mywindow.close();

    this.log.addLog({
      action: "Print",
      component: "Result",
      details: `Printed Result`,
    }).subscribe();

  }
}
